<template>
  <b-modal
    v-model="internalShowModal"
    :title="$t('deviceinfodetails')"
    size="xl"
    hide-footer
  >
    <div class="form-container">
      <div class="form-section">
        <h5 class="section-title">
          {{ $t('deviceinfo') }}
        </h5>
        <div class="form-row">
          <b-form-group :label="$t('sndevice')">
            <b-form-input
              :value="details.serialNumber || ''"
              class="input-box"
              disabled
            />
          </b-form-group>
          <b-form-group :label="$t('devicename')">
            <b-form-input
              :value="details.deviceName || ''"
              class="input-box"
              disabled
            />
          </b-form-group>
          <b-form-group :label="$t('model')">
            <b-form-input
              :value="details.model || ''"
              class="input-box"
              disabled
            />
          </b-form-group>
          <b-form-group :label="$t('devicecate')">
            <b-form-input
              :value="details.category && details.category.name || ''"
              class="input-box"
              disabled
            />
          </b-form-group>
          <b-form-group :label="$t('devicesubcate')">
            <b-form-input
              :value="details.subcategory && details.subcategory.name || ''"
              class="input-box"
              disabled
            />
          </b-form-group>
          <b-form-group :label="$t('cost')">
            <b-form-input
              :value="formattedPrice"
              class="input-box"
              disabled
            />
          </b-form-group>
        </div>
      </div>

      <div class="form-section">
        <h5 class="section-title">
          {{ $t('userinfo') }}
        </h5>
        <div class="form-row">
          <b-form-group :label="$t('user')">
            <b-form-input
              :value="details.user && details.user.username || $t('other')"
              class="input-box"
              disabled
            />
          </b-form-group>
          <b-form-group :label="$t('deptname')">
            <b-form-input
              :value="details.department && details.department.dept || ''"
              class="input-box"
              disabled
            />
          </b-form-group>
          <b-form-group :label="$t('locationname')">
            <b-form-input
              :value="details.location && details.location.locationName || ''"
              class="input-box"
              disabled
            />
          </b-form-group>
          <b-form-group :label="$t('getdevice')">
            <b-form-input
              :value="details.purchaseDate ? new Date(details.purchaseDate).toLocaleDateString() : ''"
              class="input-box"
              disabled
            />
          </b-form-group>
        </div>
      </div>
    </div>

    <div class="form-container">
      <div class="form-section">
        <h5 class="section-title">
          {{ $t('warrantydevice') }}
        </h5>
        <!-- warranty form -->
        <div style="max-height: 200px; overflow-y: auto;">
          <b-table
            :items="warranty"
            :fields="warrantyFields"
            class="mt-3"
            bordered
          >
            <template #empty>
              <div>{{ $t('nodatawarranty') }}</div>
            </template>
            <template #cell(vendor)="data">
              <span>{{ data.item.vendor }}</span>
            </template>
            <template #cell(warrantyDay)="data">
              <span>
                {{ data.item.warrantyDay && data.item.warrantyDay > 0 ? formatWarrantyDay(data.item.warrantyDay) : this.$t('nowarranty') }}
              </span>
            </template>
            <template #cell(warrantyExp)="data">
              <span
                v-if="data.item.warrantyExp !== null"
                :style="{ color: formatWarrantyExp(data.item.warrantyExp).color }"
              >
                {{ formatWarrantyExp(data.item.warrantyExp).text }}
              </span>
              <span v-else />
            </template>
            <template #cell(warrantyNote)="data">
              <span>{{ data.item.warrantyNote }}</span>
            </template>
          </b-table>
        </div>
      </div>

      <div class="form-section">
        <h5 class="section-title">
          {{ $t('hardwaredetails') }}
        </h5>
        <!-- Device Hardware Table -->
        <div style="max-height: 200px; overflow-y: auto;">
          <b-table
            :items="hardware"
            :fields="deviceHardwareFields"
            class="mt-3"
            bordered
          >
            <template #empty>
              <div>{{ $t('nodetailshardware') }}</div>
            </template>
            <template #cell(cpu)="data">
              <span style="white-space: nowrap;">{{ data.item.cpu || '' }}</span>
            </template>
            <template #cell(ram)="data">
              <span style="white-space: nowrap;">{{ data.item.ram || '' }}</span>
            </template>
            <template #cell(display)="data">
              <span style="white-space: nowrap;">{{ data.item.display || '' }}</span>
            </template>
            <template #cell(harddisk)="data">
              <span style="white-space: nowrap;">{{ data.item.harddisk || '' }}</span>
            </template>
            <template #cell(ssd)="data">
              <span style="white-space: nowrap;">{{ data.item.ssd || '' }}</span>
            </template>
            <template #cell(ip)="data">
              <span style="white-space: nowrap;">{{ data.item.ip || '' }}</span>
            </template>
            <template #cell(details)="data">
              <span>{{ data.item.details || '' }}</span>
            </template>
            <template #cell(macAdd)="data">
              <span style="white-space: nowrap;">{{ data.item.macAdd || '' }}</span>
            </template>
          </b-table>
        </div>
      </div>
    </div>

    <div class="form-container">

      <div class="form-section">
        <h5 class="section-title">
          {{ $t('expenseinfo') }}
        </h5>
        <div style="max-height: 200px; overflow-y: auto;">
          <b-table
            :items="expensefix"
            :fields="expenseFields"
            class="mt-3"
            bordered
          >
            <!-- แสดงชื่อของหมวดหมู่หลัก -->
            <template #cell(expenseCateName)="data">
              <span>{{ data.item.expenseCate ? data.item.expenseCate.name || '' : '' }}</span>
            </template>

            <!-- แสดงชื่อของหมวดหมู่ย่อย -->
            <template #cell(expenseSubcateName)="data">
              <span>{{ data.item.expenseSubcate ? data.item.expenseSubcate.name || '' : '' }}</span>
            </template>

            <template #cell(cost)="data">
              <span>
                {{ isSum(data.item.cost) ? totalCost + ' ฿' : (data.item.cost || 0).toFixed(2) + ' ฿' }}
              </span>
            </template>
          </b-table>
        </div>
        <div style="font-weight: bold; margin-top: 10px;">
          {{ $t('totalcost') }}: {{ totalCost }} ฿
        </div>
      </div>

      <div class="form-section">
        <h5 class="section-title">
          {{ $t('spareinfo') }}
        </h5>
        <div style="max-height: 200px; overflow-y: auto;">
          <b-table
            :items="spare"
            :fields="spareFields"
            class="mt-3"
            bordered
          >
            <template #cell(orderlist)="data">
              <span>{{ data.item.orderlist }}</span>
            </template>
            <template #cell(list)="data">
              <span>{{ data.item.list }}</span>
            </template>
            <template #cell(purchase)="data">
              <span>{{ data.item.purchase }}</span>
            </template>
            <template #cell(quantity)="data">
              <span>{{ data.item.quantity }}</span>
            </template>
            <template #cell(cost)="data">
              <span>
                {{ data.item.list === 'รวม' ? totalSpareCost + ' ฿' : (data.item.cost || 0).toFixed(2) + ' ฿' }}
              </span>
            </template>
            <template #cell(source)="data">
              <span>{{ data.item.source }}</span>
            </template>
            <template #cell(detail)="data">
              <span>{{ data.item.detail }}</span>
            </template>
          </b-table>
        </div>
        <div style="font-weight: bold; margin-top: 10px;">
          {{ $t('totalcost') }}: {{ spareCost }} ฿
        </div>
      </div>
    </div>

    <div class="form-container">
      <div class="form-section">
        <h5 class="section-title">
          {{ $t('fixhistory') }}
        </h5>
        <!-- fix history Table -->
        <div style="max-height: 200px; overflow-y: auto;">
          <b-table
            :items="fixhistory"
            :fields="fixhistoryFields"
            class="mt-3"
            bordered
          >

            <template #cell(order)="data">
              <span style="white-space: nowrap;">{{ data.item.order || '' }}</span>
            </template>
            <template #cell(timefix)="data">
              {{ new Date(data.item.timefix).toLocaleString('th-TH', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
              }) || '' }}
            </template>

            <template #cell(category)="data">
              <span style="white-space: nowrap;">{{ data.item.category ? data.item.category.nameCate || '' : '' }}</span>

            </template>
            <template #cell(subcategory)="data">
              <span style="white-space: nowrap;">{{ data.item.subcategory ? data.item.subcategory.name || '' : '' }}</span>
            </template>

            <template #cell(device)="data">
              <span style="white-space: nowrap;">{{ data.item.device ? data.item.device.deviceName || '' : '' }}</span>
            </template>

            <template #cell(user)="data">
              <span style="white-space: nowrap;">{{ data.item.user ? data.item.user.username || $t('user') : '' }}</span>
            </template>

            <template #cell(fixDetails)="data">
              <span>
                {{ data.item.fixDetails && Array.isArray(data.item.fixDetails) ? data.item.fixDetails.map(detail => detail.detail ? detail.detail.substring(0, 5) + (detail.detail.length > 5 ? '...' : '') : '').join(', ') : '' }}
              </span>
            </template>

            <template #cell(fixDetailsAdditional)="data">
              <span>
                {{ data.item.fixDetailsAdditional && Array.isArray(data.item.fixDetailsAdditional) ? data.item.fixDetailsAdditional.map(addDetail => addDetail.fixdetail ? addDetail.fixdetail.substring(0, 5) + (addDetail.fixdetail.length > 5 ? '...' : '') : '').join(', ') : '' }}
              </span>
            </template>

            <template #cell(operator)="data">
              <span style="white-space: nowrap;">{{ data.item.operator || '' }}</span>

            </template>

            <template #cell(status)="data">
              <span style="white-space: nowrap;">{{ data.item.status && data.item.status.statusName ? data.item.status.statusName : '' }}</span>
            </template>
          </b-table>

        </div>
        <div style="font-weight: bold; margin-top: 10px;">
          {{ $t('amount') }}: <b>{{ fixHistoryCount }}</b> {{ $t('list') }}
        </div>
      </div>

      <div class="form-section">
        <h5 class="section-title">
          {{ $t('userdevicehistory') }}
        </h5>
        <!-- Device history Table -->
        <div style="max-height: 200px; overflow-y: auto;">
          <b-table
            :items="devicehistory"
            :fields="deviceHistoryFields"
            class="mt-3"
            bordered
          >
            <template #empty>
              <div>{{ $t('nondevicedetails') }}</div>
            </template>
            <template #cell(empid)="data">
              <span style="white-space: nowrap;">{{ data.item.user.empid || '' }}</span>
            </template>
            <template #cell(username)="data">
              <span style="white-space: nowrap;">{{ data.item.user.username || '' }}</span>
            </template>
            <template #cell(email)="data">
              <span style="white-space: nowrap;">{{ data.item.user.email || '' }}</span>
            </template>
            <template #cell(roles)="data">
              <span style="white-space: nowrap;">{{ getRoleName(data.item.user.roles) || '' }}</span>
            </template>
            <template #cell(dept)="data">
              <span style="white-space: nowrap;">{{ data.item.user.dept.dept || '' }}</span>
            </template>
            <template #cell(jobtitle)="data">
              <span style="white-space: nowrap;">{{ data.item.user.jobtitle.titleName || '' }}</span>
            </template>
            <template #cell(phone)="data">
              <span style="white-space: nowrap;">{{ data.item.user.phone || '' }}</span>
            </template>
            <template #cell(note)="data">
              <span>{{ data.item.note || '' }}</span>
            </template>
            <template #cell(startTime)="data">
              {{ new Date(data.item.startTime).toLocaleString('th-TH', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
              }) || '' }}
            </template>
            <template #cell(endTime)="data">
              <span>
                {{ data.item.endTime ? new Date(data.item.endTime).toLocaleString('th-TH', {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit',
                }) : '' }}
              </span>
            </template>
          </b-table>
        </div>
        <div>
          <div style="font-weight: bold; margin-top: 10px;">
            {{ $t('amount') }}: {{ devicehistoryCount }} {{ $t('list') }}
          </div>
        </div>
      </div>
    </div>

    <!-- pm history -->
    <div class="form-container">
      <div class="form-section">
        <h5 class="section-title">
          {{ $t('pmhistory') }}
        </h5>
        <div style="max-height: 200px; overflow-y: auto;">
          <b-table
            :items="pmhistory"
            :fields="pmhistoryFields"
            class="mt-3"
            bordered
          >
            <template #cell(title)="data">
              <span style="white-space: nowrap;">{{ data.item ? data.item.title : '' }}</span>
            </template>

            <template #cell(description)="data">
              <span style="white-space: nowrap;">{{ data.item ? data.item.description : '' }}</span>
            </template>

            <template #cell(deviceName)="data">
              <span style="white-space: nowrap;">{{ data.item.device ? data.item.device.deviceName : '' }}</span>
            </template>

            <template #cell(timestart)="data">
              <span>
                {{ data.item && data.item.timestart ?
                  new Date(data.item.timestart).toLocaleString('th-TH', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                  }) : '' }}
              </span>
            </template>

            <template #cell(timeend)="data">
              <span>
                {{ data.item && data.item.timeend ?
                  new Date(data.item.timeend).toLocaleString('th-TH', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                  }) : '' }}
              </span>
            </template>
          </b-table>
        </div>
        <div style="font-weight: bold; margin-top: 10px;">
          {{ $t('amount') }}: <b>{{ pmHistoryCount }}</b> {{ $t('list') }}
        </div>
      </div>

      <div class="form-section">
        <p><strong>{{ $t('assetType') }}:</strong> {{ details.purchaseStatus || '' }}</p>
        <p><strong>{{ $t('devicestatus') }}:</strong>
          {{ details.status || '' }}
          <span v-if="isDiscontinued"> ({{ $t('outofdate') }}: {{ formattedDisDate }})</span>
        </p>
        <p>{{ $t('detailsanother') }}</p>
        <div class="info-box">
          {{ details.details || '' }}
        </div>
      </div>
    </div>

    <p><strong>{{ $t('image') }}:</strong></p>
    <div v-if="imageUrls.length > 0">
      <b-img
        v-for="(url, index) in imageUrls"
        :key="index"
        :src="url"
        alt="Device Image"
        class="img-thumbnail mb-2"
        fluid
        @click="showImage(url)"
      />
    </div>
    <div v-else>
      {{ $t('noimage') }}
    </div>

    <template #modal-footer>
      <b-button
        variant="secondary"
        @click="closeModal"
      >
        {{ $t('close') }}
      </b-button>
    </template>
    <!-- Image Modal -->
    <b-modal
      v-model="imageModalShow"
      size="lg"
      :title="$t('showimage')"
      hide-footer
      @hidden="handleImageClose"
    >
      <b-img
        :src="selectedImage"
        alt="Large Image"
        fluid
      />
    </b-modal>
  </b-modal>
</template>

<script>
import apiMst from '@/services/masterDate'

export default {
  props: {
    localShowModal: {
      type: Boolean,
      default: false,
    },
    details: {
      type: Object,
      default: () => ({}),
    },
    warranty: {
      type: Array,
      default: () => ([]),
    },
    hardware: {
      type: Array,
      default: () => ([]),
    },
    fixhistory: {
      type: Array,
      default: () => ([]),
    },
    pmhistory: {
      type: Array,
      default: () => ([]),
    },
    expensefix: {
      type: Array,
      default: () => ([]),
    },
    devicehistory: {
      type: Array,
      default: () => ([]),
    },
    spare: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      selectedImage: null,
      imageModalShow: false,
      imageUrls: [],
      internalShowModal: this.localShowModal,
    }
  },
  computed: {
    totalCost() {
    // ตรวจสอบว่า expensefix มีข้อมูลก่อนคำนวณ
      if (this.expensefix && Array.isArray(this.expensefix)) {
        return this.expensefix.reduce((total, item) => total + (item.cost || 0), 0).toFixed(2)
      }
      return '0.00'
    },
    fixHistoryCount() {
      return this.fixhistory.length
    },
    pmHistoryCount() {
      return this.pmhistory ? this.pmhistory.length : 0
    },
    spareCost() {
    // ตรวจสอบว่า expensefix มีข้อมูลก่อนคำนวณ
      if (this.spare && Array.isArray(this.spare)) {
        return this.spare.reduce((total, item) => total + (item.cost || 0), 0).toFixed(2)
      }
      return '0.00'
    },
    devicehistoryCount() {
      return this.devicehistory.length
    },
    isDiscontinued() {
      return this.details.status === 'เลิกใช้งาน' || this.details.status === 'ขายเศษซาก'
    },
    formattedDisDate() {
      if (this.details.disDate) {
        const date = new Date(this.details.disDate)
        return date.toLocaleDateString('th-TH', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        })
      }
      return ''
    },
    formattedPrice() {
      if (this.details.price) {
        return `${this.details.price.toFixed(2)} ฿`
      }
      return ''
    },
    warrantyFields() {
      return [
        { key: 'vendor', label: this.$t('vendor'), thClass: 'text-center' },
        { key: 'warrantyDay', label: this.$t('warrantyday'), thClass: 'text-center' },
        { key: 'warrantyExp', label: this.$t('warrantyExp'), thClass: 'text-center' },
        { key: 'warrantyNote', label: this.$t('remark'), thClass: 'text-center' },
      ]
    },
    deviceHardwareFields() {
      return [
        { key: 'cpu', label: 'CPU', thClass: 'text-center' },
        { key: 'ram', label: 'RAM', thClass: 'text-center' },
        { key: 'display', label: 'Display', thClass: 'text-center' },
        { key: 'harddisk', label: 'Hard Disk', thClass: 'text-center' },
        { key: 'ssd', label: 'SSD', thClass: 'text-center' },
        { key: 'ip', label: 'IP Address', thClass: 'text-center' },
        { key: 'macAdd', label: 'MAC Address', thClass: 'text-center' },
        { key: 'mouse', label: 'Mouse', thClass: 'text-center' },
        { key: 'keyboard', label: 'Keyboard', thClass: 'text-center' },
        { key: 'ups', label: 'UPS', thClass: 'text-center' },
        { key: 'details', label: this.$t('remark'), thClass: 'text-center' },
      ]
    },
    fixhistoryFields() {
      return [
        { key: 'order', label: this.$t('placeholderOrderFix'), thClass: 'text-center' },
        { key: 'timefix', label: this.$t('fixDate'), thClass: 'text-center' },
        { key: 'category', label: this.$t('cate'), thClass: 'text-center' },
        { key: 'subcategory', label: this.$t('subcate'), thClass: 'text-center' },
        { key: 'device', label: this.$t('device'), thClass: 'text-center' },
        { key: 'user', label: this.$t('user'), thClass: 'text-center' },
        { key: 'fixDetails', label: this.$t('fixDetails'), thClass: 'text-center' },
        { key: 'fixDetailsAdditional', label: this.$t('problem'), thClass: 'text-center' },
        { key: 'operator', label: this.$t('operator'), thClass: 'text-center' },
        { key: 'status', label: this.$t('status'), thClass: 'text-center' },
      ]
    },
    pmhistoryFields() {
      return [
        { key: 'title', label: this.$t('titlename'), thClass: 'text-center' },
        { key: 'description', label: this.$t('details'), thClass: 'text-center' },
        { key: 'deviceName', label: this.$t('devicename'), thClass: 'text-center' },
        { key: 'timestart', label: this.$t('starttime'), thClass: 'text-center' },
        { key: 'timeend', label: this.$t('endtime'), thClass: 'text-center' },
      ]
    },
    expenseFields() {
      return [
        { key: 'expenseCateName', label: this.$t('expenseCateName'), thClass: 'text-center' },
        { key: 'expenseSubcateName', label: this.$t('expenseSubcateName'), thClass: 'text-center' },
        { key: 'cost', label: this.$t('expense'), thClass: 'text-center' },
        { key: 'note', label: this.$t('remark'), thClass: 'text-center' },
      ]
    },
    spareFields() {
      return [
        { key: 'orderlist', label: this.$t('orderlist') },
        { key: 'list', label: this.$t('list') },
        { key: 'purchase', label: this.$t('orderbuy') },
        { key: 'quantity', label: this.$t('amount') },
        { key: 'cost', label: this.$t('cost') },
        { key: 'source', label: this.$t('sourcespare') },
        { key: 'detail', label: this.$t('remark') },
      ]
    },
    deviceHistoryFields() {
      return [
        { key: 'empid', label: this.$t('workerid'), thClass: 'text-center' },
        { key: 'username', label: this.$t('user'), thClass: 'text-center' },
        { key: 'email', label: this.$t('email'), thClass: 'text-center' },
        { key: 'roles', label: this.$t('role'), thClass: 'text-center' },
        { key: 'dept', label: this.$t('deptname'), thClass: 'text-center' },
        { key: 'jobtitle', label: this.$t('jobtitle'), thClass: 'text-center' },
        { key: 'phone', label: this.$t('phone'), thClass: 'text-center' },
        { key: 'note', label: this.$t('remark'), thClass: 'text-center' },
        { key: 'startTime', label: this.$t('startuse'), thClass: 'text-center' },
        { key: 'endTime', label: this.$t('enduse'), thClass: 'text-center' },
      ]
    },
  },
  watch: {
    localShowModal(newVal) {
      this.internalShowModal = newVal
    },
    internalShowModal(newVal) {
      this.$emit('update:localShowModal', newVal)
    },
    details(newVal) {
      if (newVal && Object.keys(newVal).length > 0) {
        this.fetchImages()
        this.internalShowModal = true
      } else {
        this.internalShowModal = false
      }
    },
    hardware(newVal) {
      console.log('Hardware data updated:', newVal)
      if (Array.isArray(newVal) && newVal.length > 0) {
        console.log('Using first hardware object:', newVal[0])
      } else {
        console.log('Hardware data is not an array or is empty.')
      }
    },
    fixhistory(newVal) {
      console.log('fixhistory data updated:', newVal)
      if (Array.isArray(newVal) && newVal.length > 0) {
        console.log('Using first fixhistory object:', newVal[0])
      } else {
        console.log('fixhistory data is not an array or is empty.')
      }
    },
    pmhistory(newVal) {
      console.log('pmhistory data updated:', newVal)
      if (Array.isArray(newVal) && newVal.length > 0) {
        console.log('Using first pmhistory object:', newVal[0])
      } else {
        console.log('pmhistory data is not an array or is empty.')
      }
    },
    devicehistory(newVal) {
      console.log('devicehistory data updated:', newVal)
      if (Array.isArray(newVal) && newVal.length > 0) {
        console.log('Using first devicehistory object:', newVal[0])
      } else {
        console.log('devicehistory data is not an array or is empty.')
      }
    },
    expensefix(newVal) {
      console.log('expensefix data updated:', newVal)
      if (Array.isArray(newVal) && newVal.length > 0) {
        console.log('Using first expensefix object:', newVal[0])
      } else {
        console.log('expensefix data is not an array or is empty.')
      }
    },
    spare(newVal) {
      console.log('spare data updated:', newVal)
      if (Array.isArray(newVal) && newVal.length > 0) {
        console.log('Using first spare object:', newVal[0])
      } else {
        console.log('spare data is not an array or is empty.')
      }
    },
    warranty(newVal) {
      console.log('Warranty updated:', newVal)
    },
  },
  mounted() {
    if (this.details && typeof this.details === 'object' && Object.keys(this.details).length) {
      this.fetchImages()
    } else {
      console.warn('Device details are not set correctly.')
    }
  },
  methods: {
    isSum(cost) {
      return cost === this.$t('sum')
    },
    async fetchImages() {
      const apiBaseUrl = process.env.VUE_APP_API_BASE_URL || 'https://mns.gelogs.co.th/api/'
      try {
        const response = await apiMst.get(`/images/${this.details.id}`)
        this.imageUrls = response.data.map(filePath => `${apiBaseUrl}${filePath}`)
      } catch (error) {
        console.warn('warning: fetching images')
        this.imageUrls = []
      }
    },
    formatWarrantyDay(totalDays) {
      const years = Math.floor(totalDays / 365)
      const months = Math.floor((totalDays % 365) / 30)
      const days = totalDays % 30

      let result = ''
      if (years > 0) {
        result += `${years} ${this.$t('year')} `
      }
      if (months > 0) {
        result += `${months} ${this.$t('month')} `
      }
      if (years === 0 && months === 0 && days > 0) {
        result += `${days} ${this.$t('day')}`
      }

      return result.trim() || '0 วัน'
    },
    formatWarrantyExp(expDate) {
      const exp = new Date(expDate)
      const now = new Date()

      now.setHours(0, 0, 0, 0)
      exp.setHours(0, 0, 0, 0)

      const diffTime = exp - now
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24))
      const diffHours = Math.floor((diffTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))

      let color = 'black'
      if (diffDays < 0) {
        color = 'red'
      } else if (diffDays <= 30) {
        color = 'orange'
      }

      let timeLeft = ''
      if (diffDays < 0) {
        timeLeft = this.$t('exp')
      } else {
        timeLeft = this.$t('after')
        if (diffDays > 0) {
          timeLeft += `${diffDays} ${this.$t('day')} `
        } else if (diffHours > 0) {
          timeLeft += `${diffHours} ${this.$t('hour')}`
        } else {
          timeLeft += this.$t('inday')
        }
      }

      const formattedDate = `${exp.getDate()}/${exp.getMonth() + 1}/${exp.getFullYear() + 543}`

      return {
        text: `${formattedDate} (${timeLeft.trim()})`,
        color,
      }
    },
    closeModal() {
      this.internalShowModal = false // ปิด modal
      this.$emit('close') // ส่ง event กลับไปที่ parent
    },
    resetDetails() {
      this.$emit('resetDetails') // ส่ง event reset ไปที่ parent
    },
    showImage(url) {
      this.selectedImage = url
      this.imageModalShow = true
    },
    handleImageClose() {
      this.selectedImage = ''
    },
    getRoleName(roles) {
      return roles?.[0]?.name || ''
    },
    isValidDate(value) {
      const date = new Date(value)
      return !isNaN(date.getTime())
    },
    handleCloseModal() {
      this.$emit('update:localShowModal', false)
    },
  },
}
</script>
<style scoped>
.info-box {
  border: 1px solid #ccc; /* กรอบ */
  border-radius: 4px; /* มุมโค้ง */
  padding: 10px; /* เพิ่ม padding */
  background-color: #f9f9f9; /* สีพื้นหลัง */
  margin-top: 5px; /* ระยะห่างด้านบน */
  max-height: 12vh; /* ความสูงสูงสุด */
  overflow-y: auto; /* สร้าง scroll bar ถ้าข้อความยาว */

  /* กำหนดขนาดให้ responsive */
  height: 12vh;
  min-width: 5vw; /* ขนาดเล็กสุด */
  min-height: 5vh; /* ความสูงเล็กสุด */
  max-width: 20vw; /* ขนาดสูงสุด */
  width: 20vw; /* ขนาดปกติ */

  /* ใช้ media query เพื่อปรับขนาดตามหน้าจอ */
  @media (max-width: 768px) {
    width: 90%; /* ขยายให้เต็มความกว้างเมื่ออยู่ในมือถือ */
    max-width: 90%;
    min-width: 5vw; /* ขนาดเล็กสุด */
  }
}
.text-center {
  text-align: center;
}

.form-container {
  display: flex;
  justify-content: space-between; /* หรือ flex-start ตามที่ต้องการ */
  gap: 20px; /* ระยะห่างระหว่างสองกล่อง */
  flex-wrap: wrap /* ให้กล่องย่อไปตามพื้นที่ที่มี */
}
.section-title {
  background-color: #4a6a8c;
  color: white;
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 15px;
}
.form-section {
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #f9f9f9;
}
.form-section {
  flex: 1;
  min-width: 300px;
  max-width: 100%;
  box-sizing: border-box;
  white-space: nowrap;
}
.form-row {
  display: flex;
  gap: 20px;
}

.img-thumbnail {
  max-width: 150px;
  max-height: 150px;
  cursor: pointer;
  transition: transform 0.2s;
}

.img-thumbnail:hover {
  transform: scale(1.05);
}

@media (max-width: 768px) {
  .form-container {
    flex-direction: column; /* แสดงในแนวตั้งบนหน้าจอเล็ก */
  }
}
</style>
